<template>
  <div class="arp-review">
    <dl class="arp-review__grid">
      <div v-if="draft.fornecedorNome" class="arp-review__item">
        <dt>Fornecedor</dt>
        <dd>{{ draft.fornecedorNome }}</dd>
      </div>

      <div class="arp-review__item">
        <dt>Número</dt>
        <dd>{{ draft.numero || '—' }}</dd>
      </div>

      <div class="arp-review__item">
        <dt>Ano</dt>
        <dd>{{ draft.ano || '—' }}</dd>
      </div>

      <div v-if="mostraAssinatura" class="arp-review__item">
        <dt>Assinatura</dt>
        <dd>{{ formatDate(draft.dataAssinatura) }}</dd>
      </div>

      <div class="arp-review__item">
        <dt>Vigência</dt>
        <dd>{{ formatDate(draft.vigenciaInicio) }} a {{ formatDate(draft.vigenciaFim) }}</dd>
      </div>

      <div class="arp-review__item">
        <dt>Permitir carona</dt>
        <dd>{{ draft.permitirCarona ? 'Sim' : 'Não' }}</dd>
      </div>

      <div v-if="journey.type === 'propria' && !isEdit" class="arp-review__item">
        <dt>Arquivo</dt>
        <dd>{{ nomeArquivo || '—' }}</dd>
      </div>

      <div v-if="mostraItens" class="arp-review__item arp-review__item--full">
        <dt>Itens</dt>
        <dd>{{ itensLabel }}</dd>
      </div>
    </dl>

    <b-field
      v-if="isRetificacao"
      class="arp-review__justificativa"
      label="Justificativa da retificação"
      :type="justificativaInvalida ? 'is-danger' : ''"
      :message="justificativaInvalida ? 'Informe entre 10 e 255 caracteres' : ''"
    >
      <b-input
        :value="draft.justificativa"
        type="textarea"
        maxlength="255"
        rows="3"
        placeholder="Descreva o motivo da retificação (exigência PNCP)"
        @input="v => atualizarArpDraft({ justificativa: v })"
      />
    </b-field>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { formatarDataFormularioIso } from '@/utils/format';

export default {
  name: 'ArpReview',
  computed: {
    ...mapGetters({
      draft: 'obterArpDraft',
      journey: 'obterArpJourney',
    }),
    isEdit() {
      return this.journey.mode === 'edit';
    },
    isRetificacao() {
      return this.isEdit && this.journey.isRascunho === false;
    },
    mostraAssinatura() {
      return this.journey.type === 'propria' || this.isRetificacao;
    },
    mostraItens() {
      if (this.isRetificacao) return false;
      return this.journey.type === 'reserva';
    },
    nomeArquivo() {
      const a = this.draft.arquivo;
      if (!a) return '';
      return Array.isArray(a) ? a[0]?.name : a.name;
    },
    itensLabel() {
      const nums = this.draft.itensSelecionados || [];
      return nums.length ? nums.join(', ') : '—';
    },
    justificativaInvalida() {
      if (!this.isRetificacao) return false;
      const j = String(this.draft.justificativa || '').trim();
      return j.length > 0 && (j.length < 10 || j.length > 255);
    },
  },
  methods: {
    ...mapActions(['atualizarArpDraft']),
    formatDate(iso) {
      return formatarDataFormularioIso(iso) || '—';
    },
  },
};
</script>

<style scoped>
.arp-review__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem 1.5rem;
  margin: 0;
}

.arp-review__item dt {
  font-size: 0.75rem;
  color: #7a7a7a;
  margin-bottom: 0.25rem;
}

.arp-review__item dd {
  margin: 0;
  font-weight: 600;
  color: #363636;
}

.arp-review__item--full {
  grid-column: 1 / -1;
}

.arp-review__justificativa {
  margin-top: 1.5rem;
  text-align: left;
}

@media (max-width: 768px) {
  .arp-review__grid {
    grid-template-columns: 1fr;
  }
}
</style>
